import type React from 'react';

import { useGetList } from '@vlabs/api/artemy/client';
import type { TopMatchingCandidatesLabel } from '@vlabs/api/luna-api/model/TopMatchingCandidatesLabel';
import { isUUID } from '@vlabs/shared/validators';
import { Link } from '@vlabs/uikit/components/controls/link/Link';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath } from 'react-router-dom';

import st from './shared.module.sass';

interface MatchByListOrParameterProps {
  label: TopMatchingCandidatesLabel;
}

function MatchByListOrParameter({
  label,
}: MatchByListOrParameterProps): string | React.JSX.Element {
  // UUID в label означает совпадение по списку
  const isListMatch = isUUID(label);
  const { data: list } = useGetList(label, {
    query: { enabled: isListMatch },
  });

  if (!isListMatch) return label;
  // если список не найден, показываем исходный UUID из события
  if (!list?.user_data) return label;

  return (
    <Link
      className={st.Link}
      size="large"
      to={generatePath(routes.lists.read, { listId: label })}
    >
      {list.user_data}
    </Link>
  );
}

export { MatchByListOrParameter };
